import { getI18n } from "@editor/ui-utils";
const de = {
  users: {
    backButton: "Zurück zur Nutzerliste",
    email: "E-Mail-Adresse",
    firstName: "Vorname",
    lastName: "Nachname",
    resetPW: "Passwort zurücksetzen",
    resetPWInfo: "Es wird eine Email mit Informationen zum Zurücksetzen des Passworts an den Nutzer geschickt",
    reset2FA: "2-FA & Passwort zurücksetzen",
    reset2FAInfo: "Es wird eine Email mit Informationen zum Zurücksetzen der 2-Faktor Authentifizierung und des Passworts an den Nutzer geschickt",
    saveAndCreate: "Speichern & Autor erstellen",
    active: "Aktiv",
    messageMandatoryInformation: "Du kannst nicht speichern, da dem Nutzer benötigte Informationen fehlen",
    messageUpdated: "Nutzer aktualisiert",
    messageCreated: "Nutzer erstellt",
    messageBlocked: "Nutzer gesperrt",
    messageActive: "Nutzer aktiv",
    requiredFields: "Sie können den User nicht speichern, da Pflichtangaben fehlen",
    router: {
      editUser: "Benutzer bearbeiten"
    }
  },
  usersList: {
    title: "Nutzer",
    newButton: "Neuer Nutzer",
    search: "Nach Nutzername oder E-Mail-Adresse suchen",
    status: "Status",
    dpAny: "Beliebig",
    dpActive: "Aktiv",
    dpInactive: "Inaktiv",
    loading: "Lade CMS Nutzer",
    headerStatus: "Status",
    headerFirstName: "Vorname",
    headerLastName: "Nachname",
    headerEmail: "E-Mail-Adresse",
    headerCreatedAt: "Erstellt am",
    headerLastLogin: "Letzter Login",
    dpEdit: "Bearbeiten",
    dpBlock: "Blockieren",
    dpUnblock: "Unblockieren"
  }
};
const en = {
  users: {
    backButton: "Back to users list",
    email: "Email",
    firstName: "First name",
    lastName: "Last name",
    resetPW: "Reset password",
    resetPWInfo: "We will send a mail with information about resetting the password to the user",
    reset2FA: "Reset 2-FA and password",
    reset2FAInfo: "We will sent a mail with information about resetting the password and the two factor authentication to the user",
    saveAndCreate: "Save & create Author",
    active: "Active",
    messageMandatoryInformation: "You can't save because mandatory information is missing",
    messageUpdated: "User updated",
    messageCreated: "User created",
    messageBlocked: "User blocked",
    messageActive: "User active",
    requiredFields: "You can't save the user because mandatory information is missing",
    router: {
      editUser: "Edit user"
    }
  },
  usersList: {
    title: "Users",
    newButton: "New User",
    search: "Search by name or email",
    status: "Status",
    dpAny: "All",
    dpActive: "Active",
    dpInactive: "Blocked",
    loading: "Loading CMS users",
    headerStatus: "Status",
    headerFirstName: "First name",
    headerLastName: "Last name",
    headerEmail: "Email",
    headerCreatedAt: "Created at",
    headerLastLogin: "Last login",
    dpEdit: "Edit",
    dpBlock: "Block",
    dpUnblock: "Unblock"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/users",
    children: [
      {
        path: "",
        name: "user_list",
        component: () => import("./users-list.view-BwDKnoKH.js"),
        meta: { requiredRight: "navigate_list_users" }
      },
      {
        path: ":id",
        name: "user_detail",
        component: () => import("./user-edit-DLqNLl-U.js"),
        meta: { requiredRight: "navigate_user" },
        props: () => ({ title: getI18n().t("users.router.editUser") })
      }
    ]
  }
];
const userModule = {
  messages,
  routes
};
export {
  userModule
};
//# sourceMappingURL=index.es.js.map
